import { createClient } from '@supabase/supabase-js'

// Supabase configuration
const supabaseUrl = 'https://pktgljzmqosacpjuukbo.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBrdGdsanptcW9zYWNwanV1a2JvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MzY5MzYsImV4cCI6MjA4NDUxMjkzNn0.SXVi9QLrXabjhJxqL3JVwaGxO--Ij-zz9e2JlE13Stg'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
